import { Box, Text, VStack } from '@chakra-ui/react'
import { ErrorResponse, useRouteError } from 'react-router-dom'

import { PageLayoutWidget } from '../../widgets/PageLayoutWidget/PageLayoutWidget'

export type PageErrorProps = {
  error?: Error
}

export const PageError = ({ error }: PageErrorProps) => {
  const { data } = useRouteError() as ErrorResponse

  return (
    <PageLayoutWidget>
      <VStack h="full" alignItems="center" justify="center">
        <VStack flex="1" alignItems="center" justify="center">
          <Text fontSize="2xl">Page Error:</Text>
          <Text fontSize="xl">{error?.message || data || 'Unknown error'}</Text>
        </VStack>
        <Box flex="1" />
      </VStack>
    </PageLayoutWidget>
  )
}
